<script>
  import { getContext, createEventDispatcher } from 'svelte';
  import { TABS } from './Tabs.svelte';

  export let borderless = false;
  export let main = false;
  export let type = '';
  export let dark = true;

  const dispatch = createEventDispatcher();

  const tab = { type };
  const { registerTab, selectTab, selectedTab } = getContext(TABS);

  registerTab(tab);
</script>

<button
  class:dark={dark === true}
  class:selected={$selectedTab === tab}
  class:borderless
  class:main
  on:click={(e) => {
    dispatch('tabclicked', e);
    selectTab(tab);
  }}
>
  <slot />
</button>

<style>
  button {
    background: none;
    border: none;
    border-radius: 0;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    outline: none;
    cursor: pointer;
    border-bottom: 2px solid #6c81b9;
    flex: 1;
    max-width: 200px;
  }

  .dark {
    color: white;
    border-bottom: 2px solid #273353;
  }

  .borderless {
    border-bottom: none;
  }

  .main {
    border-bottom: none;
    /* max-width: 100%; */
    border-bottom: 4px solid transparent;
    text-transform: uppercase;
    font-size: 12px;
    padding-top: 6px;
  }
  .main.selected {
    background-color: #ffbf94;
    color: black;
    border-bottom: 4px solid #ffbf94;
    padding-top: 6px;
  }

  .selected {
    border-bottom: 2px solid #f22922;
    font-weight: 600;
  }
</style>
